import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "../../App.css";

import { makeStyles } from "@material-ui/core/styles";
import { Toolbar, Tooltip } from "@material-ui/core";

import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import ChromeTabs from "../../controls/ChromeTabs";

import PermitManagementStyles from "./styles/PermitManagementStyles";
import IconButton from "@material-ui/core/IconButton";
import { FastForward, FastRewind } from "@material-ui/icons";
import { getDateTabs } from "../../functions/DateTabs";
import PermitList from "./components/PermitList";
import RequiredPermitList from "./components/RequiredPermitList";

const AccessControl = require("../../AccessControl");

function PermitManagement(props) {
  const classes = makeStyles(PermitManagementStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, [
    "Super Admin",
    "Admin",
    "Manage PERMITS",
  ]);

  const [annexTabs, setAnnexTabs] = useState([
    { label: "New Permit Requirements", value: "requirements" },
    { label: "Outstanding", value: "outstanding" },
  ]);
  const [fuelTabs, setFuelTabs] = useState(
    getDateTabs(undefined, undefined, 3, 2)
  );

  const [state, setState] = useState({
    monthTabIndex: canEdit ? "outstanding" : 5,
  });

  const handleChangeMonth = (e, i) => {
    const change = { monthTabIndex: i };
    handleChange(change);
  };

  const handleChange = (change) => {
    const { month, year } =
      state.monthTabIndex === "outstanding" ||
      state.monthTabIndex === "requirements"
        ? { month: 0, year: 0 }
        : fuelTabs.values[change.monthTabIndex];
    const newState = { ...change, month, year };
    if (newState) {
      setState({
        ...state,
        ...newState,
      });
    }
  };

  const handleTabSetChange = (index) => {
    setFuelTabs(getDateTabs(fuelTabs, index, 5, 0));
  };

  const handleTabChange = (e, tab) => {
    setState({ monthTabIndex: tab });
  };

  const currentTab = (state.monthTabIndex = state.monthTabIndex || 0);
  const { month, year } =
    state.monthTabIndex === "outstanding" ||
    state.monthTabIndex === "requirements"
      ? { month: 0, year: 0 }
      : fuelTabs.values[state.monthTabIndex];

  return (
    isAuthenticated && (
      <div
        className="PermitManagement"
        style={{
          backgroundColor: "#eeeeee",
          color: "#1b4481",
          fontWeight: 400,
          fontFamily: "Ubuntu,sans-serif",
          minHeight: "100vh",
        }}
      >
        <PageHeader
          parentProps={props}
          activeMenuItem="permitmanagement"
          pageName="Permit Management"
          loggedInUser={user}
          logout={""}
        ></PageHeader>
        <div
          style={{
            marginLeft: 40,
            marginRight: 40,
            height: 2,
            backgroundColor: "#b7c3d4",
          }}
        ></div>
        <div style={{ height: 10 }}></div>

        <div
          className={classes.rooted}
          style={{ marginLeft: 20, marginRight: 20 }}
        >
          {canEdit ? (
            <Toolbar>
              <ChromeTabs
                id={"Annexes"}
                style={{ alignSelf: "flex-end" }}
                tabs={annexTabs}
                tabStyle={{
                  bgColor: "#E6E8EB",
                  selectedBgColor: "#ffffff",
                  color: "rgba(0,0,0,0.87)",
                }}
                tabProps={{
                  disableRipple: false,
                }}
                value={currentTab}
                onChange={handleTabChange}
              />
            </Toolbar>
          ) : (
            <></>
          )}
          <Toolbar>
            <div
              style={{
                width: "50px",
                marginRight: 10,
                marginLeft: 10,
                height: 45,
              }}
            >
              <IconButton
                color="primary"
                onClick={() => {
                  handleTabSetChange(-1);
                }}
              >
                <FastRewind fontSize="large" />
              </IconButton>
            </div>
            <ChromeTabs
              id={"Months"}
              style={{ alignSelf: "flex-end" }}
              tabs={fuelTabs.tabs}
              tabStyle={{
                bgColor: "#E6E8EB",
                selectedBgColor: "#ffffff",
                color: "rgba(0,0,0,0.87)",
              }}
              tabProps={{
                disableRipple: false,
              }}
              value={currentTab}
              onChange={handleChangeMonth}
            />
            <div
              style={{
                width: "50px",
                marginRight: 10,
                marginLeft: 10,
                height: 45,
              }}
            >
              <IconButton
                color="primary"
                onClick={() => {
                  handleTabSetChange(1);
                }}
              >
                <FastForward fontSize="large" />
              </IconButton>
            </div>
          </Toolbar>
        </div>
        <div
          className={classes.rooted}
          style={{
            marginLeft: 20,
            marginRight: 20,
            minHeight: `calc(100vh - ${99 + 2 + 10 + 57 + 64 + 4}px)`,
          }}
        >
          {currentTab === "requirements" ? (
            <RequiredPermitList
              classes={classes}
              canEdit={canEdit}
              month={month}
              year={year}
            />
          ) : currentTab !== "outstanding" ? (
            <PermitList
              classes={classes}
              canEdit={canEdit}
              month={month}
              year={year}
            />
          ) : (
            <PermitList
              classes={classes}
              canEdit={canEdit}
              month={month}
              year={year}
            />
          )}
        </div>

        <PageFooter></PageFooter>
      </div>
    )
  );
}

export default PermitManagement;
